module.exports = __webpack_public_path__ + "static/img/map-bg.fe7570d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/map-bg.jpg
// module id = j/vY
// module chunks = 122